<template>
  <div class="template-container">
    <!-- <div class="page-title">选择隧道超前地质预报模版!</div> -->
    <!-- 循环渲染所有模板项 -->
    <div class="template-item" :class="{ active: selectedTemplate?.value === item.value }" @click="selectTemplate(item)"
      v-for="item in templateList" :key="item.value">
      <input type="radio" :checked="selectedTemplate?.value === item.value" :value="item.value" />
      <div class="template-info">
        <div class="template-name">{{ item.name }}</div>
        <div class="template-desc">{{ item.description }}</div>
      </div>
      <span class="tag">{{ item.tag }}</span>
    </div>
    <!-- 创建Word文档按钮 -->
    <button class="create-btn" @click="createDocumentFromTemplate">基于模板创建文档</button>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { notify } from '@/utils/notify'
import type { ForecastModel } from '@/model/ForecastModel'
const router = useRouter()
const selectedTemplate = ref<ForecastModel | null>(null)
const templateList = ref<ForecastModel[]>([])
const selectTemplate = (item: ForecastModel) => {
  selectedTemplate.value = item;
  localStorage.setItem("template", JSON.stringify(item));
  console.log('选中模版' + JSON.stringify(item))
}
async function loadTemplateList() {
  try {
    const configUrl = '/templates/config.json'
    const response = await fetch(configUrl)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    templateList.value = await response.json()
  } catch (error) {
    console.error('加载模板配置失败:', error)
  }
}
onMounted(() => {
  loadTemplateList()
})

async function createDocumentFromTemplate() {
  let template = selectedTemplate.value
  if (!template) {
    notify.error('请选择模版')
    return
  }
  try {
    if (template.path && template.path.endsWith('.docx')) {
      openTemplateInNewWindow(template.path)
      notify.success('下载成功')
    }
  } catch (error) {
    notify.error('创建文档失败')
  }
}
// 最佳解决方案：直接打开模板文件
async function openTemplateInNewWindow(templatePath: string) {
  window.open(templatePath, '_blank')
}
// 从路径中提取文件名
function getFileNameFromPath(path: string): string {
  return path.split('/').pop() || 'template.docx'
}
</script>

<style scoped>
.template-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.page-title {
  font-size: 22px;
  color: #333;
  font-weight: 500;
}

.template-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.template-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
}

.template-item.active {
  border-color: #1677ff;
  background-color: #f0f7ff;
}

.template-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.template-name {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.template-desc {
  font-size: 13px;
  color: #666;
}

.tag {
  padding: 2px 8px;
  background-color: #f5f5f5;
  color: #999;
  border-radius: 4px;
  font-size: 12px;
}

.create-btn {
  height: 48px;
  background-color: #1677ff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 20px;
}

.create-btn:disabled {
  background-color: #94bfff;
  cursor: not-allowed;
}
</style>
